import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { BlankTitleInsurance } from '../../../chicago/chicago.component';
import { TitlePlusStatus } from '@models/title-insurance';
import { TitlePlusService } from '@services/title-plus/title-plus.service';
import { SnackbarService } from '@services/ui/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { TitlePlusModalComponent } from '../title-plus-modal/title-plus-modal.component';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterBusinessUser } from '@models/matter';
import { TestHooks } from './title-plus-under-review.hooks';
import { CreateDealRequest } from '@models/title-insurance/title-plus';

@Component({
	selector: 'app-title-plus-under-review',
	templateUrl: './title-plus-under-review.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitlePlusUnderReviewComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	public blankTitleInsurance = BlankTitleInsurance;
	public loading = false;
	public titlePlusStatus = TitlePlusStatus;
	@Input() matterId: string;
	@Input() thirdPartyId: string;
	@Input() status: TitlePlusStatus;

	@SelectSnapshot(SelectedMatter.titleInsurancePreviousSubmittedPayload)
	previousPayload: CreateDealRequest;
	@SelectSnapshot(SelectedMatter.assignedLawyer)
	assignedLawyer: MatterBusinessUser;

	constructor(
		private titlePlusService: TitlePlusService,
		private snackbarService: SnackbarService,
		private dialog: MatDialog,
	) {}

	async checkStatus(): Promise<void> {
		this.loading = true;
		const { matterId, thirdPartyId } = this;
		if (matterId && thirdPartyId) {
			await this.titlePlusService.updateStatus();
			this.snackbarService.openSnackBar(
				{ text: 'Order status has been updated.', type: 'info' },
				{
					duration: 3000,
					panelClass: 'ml-96',
				},
			);
		}

		this.loading = false;
	}

	openPortal() {
		this.dialog.open(TitlePlusModalComponent);
	}
}
